import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import MarketSentimentLive from "./MarketSentimentLive";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "./MarketSentimentLive/Store";
import ReactGA from 'react-ga';
ReactGA.initialize('UA-203307813-1');
ReactGA.pageview(window.location.pathname + window.location.search);
ReactDOM.render(
  <React.StrictMode>
    <Provider>
      <Router>
        <MarketSentimentLive />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
